import { useState, useEffect, useCallback, memo, useMemo } from "react";

import { pesquisarAmparo } from "../../service/ManterAmparoLegal";
import CardSeplag from "../CardSeplag";
import { PickList } from 'primereact/picklist';
import PropTypes from "prop-types";
import FiltroComponent from './FiltroComponent'

const useSelecaoAmparoLegal = (props) => {

  const [justificativasSelecionada, setJustificativasSelecionada] = useState([]);
  const [justificativasSelecionadaObject, setJustificativasSelecionadaObject] = useState({ test: '23' });

  const [justificativas, setJustificativas] = useState([]);

  useEffect(() => {
    if (props && props.amparos) {
      setJustificativasSelecionada(props.amparos)
      let dadosObject = {}
      props.amparos.forEach(e => {
        dadosObject[e.idenAmparoLegal] = e
      })
      setJustificativasSelecionadaObject(dadosObject)
    }

  }, [])

  const buscar = useCallback((filtroBodyRequest) => {

    pesquisarAmparo(filtroBodyRequest).then((res) => {

      let dadosApi = res.content
      let dados = dadosApi.filter(item => {
        if (!justificativasSelecionadaObject[item.idenAmparoLegal]) {
          return true
        }
        return false
      })
      setJustificativas(dados)
    });

  }, [justificativasSelecionadaObject])

  const handleChangeList = (event) => {
    setJustificativas(event.source);
    setJustificativasSelecionada(event.target);
    let dados = {}
    event.target.forEach(item => {
      dados[item.idenAmparoLegal] = item
    })
    setJustificativasSelecionadaObject(dados)
  }


  return {
    justificativasSelecionadaObject,
    justificativas,
    justificativasSelecionada,
    handleChangeList,
    buscar
  }

}


export default useSelecaoAmparoLegal;

export const SelecaoAmparoLegalRender = memo((props) => {

  const itemTemplate = (template) => {
    return (<h6>{template.descAmparoLegal ? template.descAmparoLegal : template.descComplementoAmparo}</h6>)
  }

  return (<>
    <div className='p-col-12' >

      <CardSeplag>
        <h6 className='p-col-12'><strong>Filtrar Amparo Legal</strong></h6>
        <FiltroComponent buscar={props.buscar} />
        <div className="p-col-12" style={{ margin: '10px auto' }}>
          <PickList
            source={props.justificativas}
            target={props.justificativasSelecionada}
            onChange={props.handleChangeList}
            itemTemplate={itemTemplate}
            sourceHeader="Resultado Filtro"
            targetHeader="Seleção de Amparo Legal"
            showSourceControls={false}
            showTargetControls={false}
          />
        </div>
      </CardSeplag>

    </div>
  </>)

})


SelecaoAmparoLegalRender.prototype = {
  justificativas: PropTypes.array.isRequired,
  justificativasSelecionada: PropTypes.array.isRequired,
  handleChangeList: PropTypes.func.isRequired,
  buscar: PropTypes.func.isRequired
}
